import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { AllocationManagerChecksResponse } from './types';

export const limitAtom = atom(500);

const allocationManagerChecksBaseAtom = atom(async (get) => {
  const limit = get(limitAtom);
  const params = new URLSearchParams({ limit: String(limit) });

  const response = await request.get<AllocationManagerChecksResponse>(
    `/admin/allocation_manager_checks?${params.toString()}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

export const allocationManagerChecksLoadableAtom = loadable(
  allocationManagerChecksBaseAtom
);
